import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { isTokenExpired } from '../utils/authToken';

const ProtectedRoute = ({ children }) => {
  const { user, loading, error, retryLoadUserProfile } = useUser();
  const token = localStorage.getItem('token');
  
  // If no token exists, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If token exists but is expired, clear it and redirect to login
  if (isTokenExpired(token)) {
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
  }
  
  // If still loading user profile, show loading state
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading your profile...</p>
        </div>
      </div>
    );
  }
  
  // If there's an error but we have a token, show error with retry option
  if (error && !user) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="alert alert-warning" role="alert">
            <h4 className="alert-heading">Connection Issue</h4>
            <p>Unable to load your profile. This might be a temporary network issue.</p>
            <hr />
            <p className="mb-0">
              <button 
                className="btn btn-primary me-2" 
                onClick={retryLoadUserProfile}
              >
                Try Again
              </button>
              <button 
                className="btn btn-outline-secondary" 
                onClick={() => {
                  localStorage.removeItem('token');
                  window.location.href = '/login';
                }}
              >
                Logout
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }
  
  // If token exists and user is loaded, render the protected component
  return children;
};

export default ProtectedRoute;
